import { Rectangle } from "./RectangleTool";
import { DMCCalendar } from "../KObjects/DMCCalendar";
import Konva from "konva";

// LIBS
const moment = require("moment");

export class Calendar extends Rectangle {
  constructor() {
    super();
    this.name = "Calendar";
    this.locale = "fr";
    this.field = "";
    this.formatDate = "LL";
    this.formatHour = "LT";
    this.targetDate = "";
    this.noText = false;
    this.color = "";
  }

  calendar(field, formatDate, formatHour, date, noText, color) {
    this.field = field;
    this.formatDate = formatDate;
    this.formatHour = formatHour;
    this.targetDate = date;
    this.noText = noText;
    this.color = color;
  }

  createControllerObject(name, konvaObject) {
    return new DMCCalendar(name, konvaObject);
  }

  createNew(controllerProject) {
    super.createNew(controllerProject);
  }

  createNewForm() {
    this.updateField();

    this.currentShapeConfig.fontFamily = "Roboto";
    this.currentShapeConfig.width = 0;
    this.currentShapeConfig.height = 0;
    this.currentShapeConfig.align = "center";
    this.currentShapeConfig.verticalAlign = "middle";
    this.currentShapeConfig.ellipsis = true;
    this.currentShapeConfig.fill = this.color;

    return new Konva.Text(this.currentShapeConfig);
  }

  mouseUp(creationController) {
    const name = super.mouseUp(creationController);
    return name;
  }

  mouseDown(controllerProject) {
    this.createNew(controllerProject);
    this.origin.x = controllerProject.collectCurrentMousePosition().x / controllerProject.scale;
    this.origin.y = controllerProject.collectCurrentMousePosition().y / controllerProject.scale;

    if (!this.interval) {
      this.interval = setInterval(() => {
        const currentMousePos = controllerProject.collectCurrentMousePosition();
        const distanceX = Math.round(Math.abs(this.origin.x - currentMousePos.x / controllerProject.scale));
        const distanceY = Math.round(Math.abs(this.origin.y - currentMousePos.y / controllerProject.scale));

        if (currentMousePos.x / controllerProject.scale < this.origin.x) {
          this.currentObject.setAttr("x", Math.round(currentMousePos.x / controllerProject.scale));
        }

        if (currentMousePos.y / controllerProject.scale < this.origin.y) {
          this.currentObject.setAttr("y", Math.round(currentMousePos.y / controllerProject.scale));
        }

        if (controllerProject.shiftKeyPressed) {
          let length = distanceX > distanceY ? distanceY : distanceX;
          length = Math.round(length);
          const fSize = Math.round((length * 2) / 3);

          this.currentObject.setAttr("width", length);
          this.currentObject.setAttr("height", length);
          this.currentObject.setAttr("fontSize", fSize);
        } else {
          this.currentObject.setAttr("width", distanceX);
          this.currentObject.setAttr("height", distanceY);
          this.currentObject.setAttr("fontSize", Math.round((distanceY * 2) / 3));
        }
        this.currentObject.field = this.field;
        this.currentObject.formatDate = this.formatDate;
        this.currentObject.formatHour = this.formatHour;
        this.currentObject.targetDate = this.targetDate;
        this.currentObject.noText = this.noText;

        this.updateCurrentOptions(
          this.currentObject.getAttr("x"),
          this.currentObject.getAttr("y"),
          this.currentObject.getAttr("width"),
          this.currentObject.getAttr("height")
        );
      }, 30);
    }
  }

  updateField() {
    const target = moment(this.targetDate);
    const today = moment();

    switch (this.field) {
      case "cal-date":
        this.currentShapeConfig.text = this.strUcFirst(moment().locale(this.locale).format(this.formatDate));
        break;
      case "cal-hour":
        this.currentShapeConfig.text = this.strUcFirst(moment().locale(this.locale).format(this.formatHour));
        break;
      case "cal-weeknum":
        this.currentShapeConfig.text = moment().locale(this.locale).week();
        break;
      case "cal-count":
        if (this.noText) {
          let nbCount = target.diff(today, "days");

          if (nbCount <= 0) {
            nbCount = nbCount * -1;
          } else {
            nbCount++;
          }

          this.currentShapeConfig.text = nbCount.toString();
        } else {
          this.currentShapeConfig.text = moment(target).endOf("day").locale(this.locale).fromNow();
        }
        break;

      default:
        this.currentShapeConfig.text = "-";
        break;
    }
  }

  strUcFirst(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}
